import Image from "next/image";
import Container from "@/app/components/ui/container";

/**
 * Header component with optional logo display above title
 */
export default function Header({
  title,
  subtitle,
  image = "https://zdpbibnixeydfncoraga.supabase.co/storage/v1/object/public/header-images//header_image-ansprechpartner.jpg",
  logoUrl,
}: {
  title: string;
  subtitle?: string;
  image?: string;
  logoUrl?: string;
}) {
  return (
    <>
      <div className="relative h-[275px] sm:h-[300px] md:h-[400px]">
        <div className="pointer-events-none absolute inset-0 bg-black/50"></div>
        <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover"
            priority={true}
            quality={100}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
        <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-b from-transparent to-black/80"></div>
        <div className="relative inset-0 z-30 flex h-full w-full items-center justify-center">
          <Container className="flex h-full w-full items-end justify-start pb-9 md:pb-20">
            <div className="text-primary-foreground flex flex-col gap-3">
              {logoUrl && (
                <div className="inline-block w-fit rounded-sm bg-white px-4 py-3">
                  <Image
                    src={logoUrl}
                    alt={`${title} Logo`}
                    width={180}
                    height={60}
                    className="h-12 w-auto object-contain sm:h-16 md:h-20"
                    priority={true}
                  />
                </div>
              )}
              <h1 className="heading-xx-large font-bold">{title}</h1>
              {subtitle && <div>{subtitle}</div>}
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
